import template from './sw-cms-block-center-text.html.twig';
import './sw-cms-block-center-text.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
